import PropTypes from 'prop-types'
import React, { Component } from 'react'

import JumpToStep from './JumpToStep'

const getErrorTextForType = (error) => {
  return ('result' in error && error.result)
    ? error.result
    : error.type
}

export default class ValidationError extends Component {

  static propTypes = {
    className: PropTypes.string,
    fieldSpecs: PropTypes.object,
    goToSection: PropTypes.func,
    readOnly: PropTypes.bool,
    steps: PropTypes.array,
    validFields: PropTypes.object,
  }

  renderErrorList(fieldName, errors) {
    return (
      <ul>
        {(errors || []).map((error) => {
          const key = `validation-error-${fieldName}-${error.type}-${error.result}`
          return (
            <li key={key}>
              {getErrorTextForType(error)}
            </li>
          )
        })}
      </ul>
    )
  }

  renderLabel(fieldName) {
    const { fieldSpecs, steps } = this.props
    let link = null
    let label = fieldName

    if (fieldSpecs && fieldName in fieldSpecs && 'label' in fieldSpecs[fieldName]) {
      link = (
        <JumpToStep
          className="jump-to-step"
          steps={steps}
          onClick={this.props.goToSection}
          which={fieldSpecs[fieldName].section}
        />
      )
      label = fieldSpecs[fieldName].label
    }
    return (
      <span>
        <strong>
          {label}
          :
        </strong>
&nbsp;
        {link}
      </span>
    )
  }

  renderFields() {

    const { validFields } = this.props
    const errors = Object.keys(validFields)
      .filter((fieldName) => !validFields[fieldName].valid)

    if (!errors.length) {
      // return null
      return <div>Es wurden alle Pflichtfelder ausgefüllt</div>
    }

    return (
      <ul className="error-fields">
        {errors.map((fieldName) => (
          <li key={`validation-error-field-${fieldName}`}>
            {this.renderLabel(fieldName)}
            {this.renderErrorList(fieldName, validFields[fieldName].errors)}
          </li>
        ))}
      </ul>
    )

  }

  render() {

    const { className, readOnly } = this.props

    if (readOnly) {
      return null
    }

    return (
      <div className={
        ['error', 'error-validation', className].join(' ').trim()
      }
      >
        <h3>Pflichtfelder</h3>
        {this.renderFields()}
      </div>
    )

  }

}



// WEBPACK FOOTER //
// ./src/shared/components/ValidationError.js